import { useNavigate } from 'react-router-dom';
import useInitialFetch from '../../services/api/useInitialFetch';
import useUrlParams from './useUrlParams';

function CartBootstrap() {
  const params = useUrlParams();
  const navigate = useNavigate();

  useInitialFetch(async (api) => {
    const data = await api.createCart(params);

    navigate(`/cart/${data.id}`, { replace: true });
  });

  return null;
}

export default CartBootstrap;
